/**
 * Internal dependencies
 */
import {
    CURRENT_UNIVERSALIMPORTER_RECEIVE,
    CURRENT_UNIVERSALIMPORTER_REQUEST,
    CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS,
    CURRENT_UNIVERSALIMPORTER_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentUniversalImporter, requestingCurrentUniversalImporter} from 'state/current-universal-importer/selectors';

/**
 * [description]
 *
 * @param  {[type]} universalimporter [description]
 * @return {[type]}         [description]
 */
export const setCurrentUniversalImporter = (universalimporter) => {
    return {
        type: CURRENT_UNIVERSALIMPORTER_RECEIVE,
    };
};

/**universalimporter
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentUniversalImporter = () => (dispatch) => {
    dispatch({
        type: CURRENT_UNIVERSALIMPORTER_REQUEST,
    });

    return cscom
        .currentUniversalImporter()
        .list()
        .then((universalimporter) => {
            dispatch({
                type: CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_UNIVERSALIMPORTER_RECEIVE,
                payload: {
                    universalimporter,
                },
            });
            return universalimporter;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_UNIVERSALIMPORTER_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_UNIVERSALIMPORTER_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentUniversalImporterIfNotRequested = (...props) => async (dispatch, getState) => {
    const currentUniversalImporter = getCurrentUniversalImporter(getState());
    const requesting = requestingCurrentUniversalImporter(getState());

    //if (!currentUniversalImporter && requesting == false) {
        return dispatch(requestCurrentUniversalImporter(...props))
    //}

    return currentUniversalImporter;
}
